module.exports = __webpack_public_path__ + "img/offer-menu.120df760.svg";